<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="工单编码（关联workorder)" prop="workorderId">
        <el-input v-model="form.workorderId" placeholder="请输入工单编码（关联workorder)" v-trim/>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="简介" prop="content">
        <el-input v-model="form.content" placeholder="请输入简介" v-trim/>
      </el-form-item>
      <el-form-item label="操作类型 0任务上报 1任务确认 2任务分配物业主管 3任务关闭 4任务分配处理人 5任务催促" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入操作类型 0任务上报 1任务确认 2任务分配物业主管 3任务关闭 4任务分配处理人 5任务催促" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象编码" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入关联对象编码" v-trim/>
      </el-form-item>
      <el-form-item label="操作前内容" prop="beforeContent">
        <el-input v-model="form.beforeContent" placeholder="请输入操作前内容" v-trim/>
      </el-form-item>
      <el-form-item label="操作后内容" prop="afterContent">
        <el-input v-model="form.afterContent" placeholder="请输入操作后内容" v-trim/>
      </el-form-item>
      <el-form-item label="参数1" prop="param1">
        <el-input v-model="form.param1" placeholder="请输入参数1" v-trim/>
      </el-form-item>
      <el-form-item label="参数2" prop="param2">
        <el-input v-model="form.param2" placeholder="请输入参数2" v-trim/>
      </el-form-item>
      <el-form-item label="参数3" prop="param3">
        <el-input v-model="form.param3" placeholder="请输入参数3" v-trim/>
      </el-form-item>
      <el-form-item label="参数4" prop="param4">
        <el-input v-model="form.param4" placeholder="请输入参数4" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaWorkorderLogWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        workorderId: '',
        title: '',
        content: '',
        objType: '',
        objId: '',
        beforeContent: '',
        afterContent: '',
        param1: '',
        param2: '',
        param3: '',
        param4: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/workorderLog',
      'field.id': 'id'
    })
  }
}
</script>
